import { stats } from "@/mocks/home";

type HeroProps = {
  onNotify: (message: string) => void;
};

export default function Hero({ onNotify }: HeroProps) {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20collage%20of%20trending%20entertainment%20news%2C%20crumpled%20warm%20vermillion%20red%20and%20amber%20gold%20paper%20shapes%2C%20torn%20magazine%20clippings%2C%20dramatic%20side%20light%2C%20deep%20espresso%20brown%20backdrop%2C%20bold%20graphic%20poster%20art%2C%20high%20contrast%2C%20no%20text&width=1600&height=900&seq=mas-hero-01&orientation=landscape"
          alt="爱黑料网官网入口导航背景图"
          title="爱黑料网官网入口 新地址 备用地址导航"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/85"></div>

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-16 text-center md:px-6 md:py-28">
        <span className="animate-rise flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse-dot"></span>
          实时校验 · 当前 4 条入口可用
        </span>

        <h1 className="animate-rise mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          爱黑料网 · 官网入口导航
          <span className="mt-3 block font-body text-base font-normal leading-relaxed text-background-200 md:text-lg">
            最新入口与备用地址同步更新，解决打不开、找不到官网的困扰。点开即看当前可用访问路径，收藏本页随时获取新地址，吃瓜不迷路。
          </span>
        </h1>

        <div className="animate-rise mt-9 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
          <button
            type="button"
            onClick={() => onNotify("正在为你打开当前可用入口…")}
            className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-arrow-right-up-line text-base"></i>
            立即前往当前入口
          </button>
          <button
            type="button"
            onClick={() => onNotify("备用地址已复制，建议同时收藏两条以上线路")}
            className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
          >
            <i className="ri-file-copy-line text-base"></i>
            复制备用地址
          </button>
        </div>

        <div className="mt-14 grid w-full max-w-4xl grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-50/15 bg-background-50/5 px-4 py-5 backdrop-blur"
            >
              <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                {item.value}
                <span className="ml-1 text-sm font-normal text-background-200">{item.unit}</span>
              </p>
              <p className="mt-1.5 text-xs text-background-200">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}